"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styled = require("@datepicker-react/styled");
var _automationHooks = require("@airportlabs/automation-hooks");
var DateParts = _interopRequireWildcard(require("./DateParts"));
var _base = require("../Icons/components/base");
var _helpers = require("../helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var propTypes = {
  /** Object that contains startDate and endDate */
  dates: _propTypes["default"].object,
  /** Function that opens/closes the DatePicker Dialog  */
  togglePopover: _propTypes["default"].func,
  /** Wether the DatePicker is open or closed - will make borders focus color */
  isOpen: _propTypes["default"].bool,
  /** Which input is currently getting set - will highlight the text for that input */
  focusedInput: _propTypes["default"].string,
  /** If there is and error on the entire field - will make borders red */
  hasError: _propTypes["default"].bool,
  /** A Luxon DateTime Format String, used to represent the date in Start and End date inputs */
  format: _propTypes["default"].string,
  /** Hook used for automation testing.For CalendarIconWrapper the suffix 'calendar' is added, for DateInput's the suffixes 'start-date' and 'end-date' are added.*/
  automationHook: _propTypes["default"].string
};
var DateSide = _styledComponents["default"].div.attrs(function (props) {
  return _objectSpread({}, (0, _helpers.getDataHookProp)(props.automationHook));
}).withConfig({
  displayName: "StartEndDates__DateSide",
  componentId: "sc-r1wiid-0"
})(["display:flex;align-items:center;justify-content:center;padding:", " ", ";width:50%;flex-shrink:0;", " ", ";& + &{border-left:1px solid ", ";}"], function (props) {
  return props.theme.fields.pV;
}, function (props) {
  return props.theme.fields.pH;
}, function (props) {
  return props.$noValue && (0, _styledComponents.css)(["color:", ";"], function (props) {
    return props.theme.colors.textSecondary;
  });
}, function (props) {
  return props.$highlight && (0, _styledComponents.css)(["color:", ";"], function (props) {
    return props.theme.colors.focus;
  });
}, function (props) {
  return props.theme.colors.border;
});
var CalendarIconWrapper = _styledComponents["default"].div.attrs(function (props) {
  return _objectSpread({}, (0, _helpers.getDataHookProp)(props.automationHook));
}).withConfig({
  displayName: "StartEndDates__CalendarIconWrapper",
  componentId: "sc-r1wiid-1"
})(["position:absolute;top:0;left:", ";height:100%;display:flex;align-items:center;"], function (props) {
  return props.theme.fields.pH;
});
var InputWrapper = (0, _styledComponents["default"])(DateParts.Input).attrs(function () {
  return {
    as: "div"
  };
}).withConfig({
  displayName: "StartEndDates__InputWrapper",
  componentId: "sc-r1wiid-2"
})(["padding:0;padding-left:calc( ", " + ", " );width:", ";", " ", ";"], function (props) {
  return props.theme.fields.pH;
}, function (props) {
  return props.theme.iconSizes.s;
}, function (props) {
  return props.width || "225px";
}, function (props) {
  return props.$isFocus && (0, _styledComponents.css)(["", "{border-color:", ";}"], DateSide, function (props) {
    return props.theme.colors.focus;
  });
}, function (props) {
  return props.$hasError && (0, _styledComponents.css)(["", "{border-color:", ";}"], DateSide, function (props) {
    return props.theme.colors.error;
  });
});
var DateInput = function DateInput(_ref) {
  var date = _ref.date,
    isStart = _ref.isStart,
    isFocused = _ref.isFocused,
    isOpen = _ref.isOpen,
    format = _ref.format,
    automationHook = _ref.automationHook;
  var formattedDate = isStart ? "Start Date" : "End Date";
  if (date) {
    formattedDate = date.toFormat(format);
  }
  return /*#__PURE__*/_react["default"].createElement(DateSide, {
    $highlight: isFocused && isOpen,
    $noValue: !date,
    automationHook: automationHook
  }, formattedDate);
};
DateInput.propTypes = {
  /** A Date object */
  date: _propTypes["default"].object,
  /** Wether it's the start date - it will show the calendar icon  */
  isStart: _propTypes["default"].bool,
  /** Wether this is the date that is getting selected now - used for highlighting  */
  isFocused: _propTypes["default"].bool,
  /** Wether the datepicker is open - used for highlighting */
  isOpen: _propTypes["default"].bool,
  /** A Luxon DateTime Format String, used to represent the date in Start and End date inputs */
  format: _propTypes["default"].string,
  /** Hook used for automation testing.*/
  automationHook: _propTypes["default"].string
};
var StartEndDates = function StartEndDates(_ref2) {
  var dates = _ref2.dates,
    togglePopover = _ref2.togglePopover,
    isOpen = _ref2.isOpen,
    focusedInput = _ref2.focusedInput,
    hasError = _ref2.hasError,
    format = _ref2.format,
    automationHook = _ref2.automationHook;
  return /*#__PURE__*/_react["default"].createElement(InputWrapper, {
    onClick: togglePopover,
    $isFocus: isOpen,
    $hasError: hasError
  }, /*#__PURE__*/_react["default"].createElement(CalendarIconWrapper, {
    automationHook: (0, _automationHooks.getHook)(automationHook, "calendar")
  }, /*#__PURE__*/_react["default"].createElement(_base.Calendar, {
    size: "s",
    color: "textSecondary"
  })), /*#__PURE__*/_react["default"].createElement(DateInput, {
    isStart: true,
    date: dates.startDate,
    isFocused: focusedInput === _styled.START_DATE,
    isOpen: isOpen,
    format: format,
    automationHook: (0, _automationHooks.getHook)(automationHook, "start-date")
  }), /*#__PURE__*/_react["default"].createElement(DateInput, {
    date: dates.endDate,
    isFocused: focusedInput === _styled.END_DATE,
    isOpen: isOpen,
    format: format,
    automationHook: (0, _automationHooks.getHook)(automationHook, "end-date")
  }));
};
StartEndDates.propTypes = propTypes;
var _default = exports["default"] = StartEndDates;